export const SET_CELL_WIRING_DATA = 'SET_CELL_WIRING_DATA'

export const setCellWiringData = cellData => {
    return {
        type: SET_CELL_WIRING_DATA,
        payload: cellData
    }
}
